import React, { useState, useEffect,useCallback ,useRef } from "react";
import axios from "axios";
import { FaSpinner } from 'react-icons/fa';
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useShop } from '../context/ShopContext';
import EmptyState from "./EmptyState";




const Stock = () => {



   const location = useLocation();
   const navigate = useNavigate(); // For navigation
   const [products, setProducts] = useState([]);
   const [filteredProducts, setFilteredProducts] = useState([]);
   const [searchQuery, setSearchQuery] = useState("");
   const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
   const [loading, setLoading] = useState(false);
   const [error, setError] = useState(null);
   const [shopId, setShopId] = useState(null);
   const [tokenString, setToken] = useState(null);
   const [shopName,setshopName] = useState(null);
   const [isClosingStockEntered, setIsClosingStockEntered] = useState(false);
   const [toastVisible, setToastVisible] = useState(false); // To prevent multiple toasts
   const inputRefs = useRef([]);
   const [apiConditionMet, setApiConditionMet] = useState(null); // null means we're waiting for the API response
    
   const [totalAmount, setTotalAmount] = useState(0);
   const [receiveTypes, setReceiveTypes] = useState([]);
   const [partyMasters, setPartyMasters] = useState([]);
   const [transferTypes, setTransferTypes] = useState([]);
   const [allProducts, setAllProducts] = useState([]);
   const [popupData, setPopupData] = useState({
     product: null,
     variant: null,
     receivedHeadId: "",
     receivedPartyMaster: "",
     receivedStockInput: "",
   });
   const [isPopupOpen, setIsPopupOpen] = useState(false);
   const [isTransferStockPopupOpen, setIsTransferStockPopupOpen] = useState(false);
   const [transferStockPopupData, setTransferStockPopupData] = useState({
     product: null,
     variant: null,
     transferHeadId: "",
     transferPartyMaster: "",
     transferStockInput: "",
   });
   const [receiveDetailDtos, setReceiveDetailDtos] = useState([]); // State to store received details
   const [submittedData, setSubmittedData] = useState(null); // Initialize submittedData state
    // State to manage the list of submitted data
    const [submittedList, setSubmittedList] = useState([]);
    const [receiveDetailDtos1, setReceiveDetailDtos1] = useState([]); // State to store received details
   const[transferDetailDtos1,settransferDetailDtos1] =useState([])
   const [isButtonDisabled, setIsButtonDisabled] = useState(false);
   const [isButtonDisabled1, setIsButtonDisabled1] = useState(false);
   const [shopOptions, setShopOptions] = useState([]); // State for shop options
   const [isLoading, setIsLoading] = useState(true); // Loading state
   const { userId ,companyId } = useShop(); // Destructure shopName from context
   const [previewData, setPreviewData] = useState([]);
   const [isSubmitting, setIsSubmitting] = useState(false);
   const [showPreview, setShowPreview] = useState(false);
   const [showPopup, setShowPopup] = useState(false);
   const [popupData1, setPopupData1] = useState(null);
   const [popupData2, setPopupData2] = useState([]); // For trnTransfer data
   const [showPopup2, setShowPopup2] = useState(false); // For controlling popup visibility
   const [updatingIndex, setUpdatingIndex] = useState(null);
   const [receivedStockData, setReceivedStockData] = useState({});
   const [transferStockData, setTransferStockData] = useState({});
   const [noStockAvailable, setNoStockAvailable] = useState(false);
 
 
 
 
 
 const showToast = (message, type = "error") => {
               toast.dismiss(); // Dismiss any existing toast before showing a new one
             
               console.log("Toast Type:", type); // Debugging log to check type value
             
               if (type.toLowerCase() === "error") {
                 toast.error(message);
               } else if (type.toLowerCase() === "success") {
                 toast.success(message);
               } else {
                 console.warn("Invalid toast type:", type);
               }
             };



 
  useEffect(() => {
     const savedShopId = localStorage.getItem("shopId");
     const savedTokenString = localStorage.getItem("tokenString");
     const savedshopName =localStorage.getItem("shopName");
   
     console.log("savedShopId: ",savedShopId)
 
     if (savedShopId && savedTokenString && savedshopName) {
       setShopId(savedShopId);
       setToken(savedTokenString);
       setshopName(savedshopName);
     } else {
       showToast("Please log in first!","error");
       navigate("/desistockentry"); // Redirect to login page if not logged in
     }
   }, [navigate]);
 
   useEffect(() => {
     if (shopId && tokenString && shopName && shopName) {
       fetchStock();
     }
   }, [shopId, tokenString, shopName,date]); // Depend on shopId and tokenString
   console.log("tokenString: ",tokenString)
 
 
 
   const typeId = 1;
  
   useEffect(() => {
     if (searchQuery.trim()) {
       const filtered = products.filter((product) =>
         product.name.toLowerCase().includes(searchQuery.toLowerCase())
       );
       setFilteredProducts(filtered);
     } else {
       setFilteredProducts(products);
     }
   }, [searchQuery, products]);
 
  useEffect(() => {
     const today = new Date();
     const formattedDate = today
       .toLocaleDateString("en-GB", {
         day: "2-digit",
         month: "short",
         year: "numeric",
       })
       .replace(",", ""); // Remove comma if any
 
     // Convert to ISO 8601 format for <input type="date">
     const isoDate = today.toISOString().split("T")[0]; // yyyy-MM-dd
     setDate(isoDate);
   }, []);
 
 
 
      // Set default from date to today's date on initial render
      useEffect(() => {
       const today = new Date();
       const isoDate = today.toISOString().split("T")[0]; // Get today's date in yyyy-MM-dd format
       setDate(isoDate); // Set the default date
     }, []);
 
 
 
    //  useEffect(() => {
    //     if (!shopId) return; // Prevent API call if shopId is not set
    
    //     const checkStockData = async () => {
    //       try {
    //         setIsLoading(true); // Start loading
    //         const response = await axios.post(
    //           "https://winenew.sipstocks.in/api/Liquor/GetCheckStock",
    //           {
    //             shopId,
    //             typeId: "1",
    //             stockDate: date || new Date().toISOString().split("T")[0], // Ensure valid date format
    //           },
    //           {
    //             headers: {
    //               'accept': '*/*',
    //               'Content-Type': 'application/json',
    //             }
    //           }
    //         );
    
    //         console.log("checkStockData:", response);
    
    //         // Check if the API response is successful and if data is true
    //         if (response.data && response.data.data === true) {
    //           setApiConditionMet(false); // Show stock report
    //           setNoStockAvailable(false); // Stock available
    //         } else {
    //           setApiConditionMet(true); // Show message
    //           setNoStockAvailable(true); // Stock available
    //         }
    //       } catch (error) {
    //         setError('Something went wrong');
    //         setApiConditionMet(true); // If error occurs, show message
    //       } finally {
    //         setIsLoading(false); // Stop loading
    //       }
    //     };
    
    //     checkStockData();
    //   }, [shopId, date]); // Trigger effect when shopId or date changes
 const checkStockData = async (customDate = date) => {
  if (!shopId) return;

  try {
    setIsLoading(true);

    const response = await axios.post(
      "https://winenew.sipstocks.in/api/Liquor/GetCheckStock",
      {
        shopId,
        typeId: "1",
        stockDate: customDate || new Date().toISOString().split("T")[0],
      },
      {
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
        },
      }
    );

    console.log("checkStockData:", response);

    if (response.data && response.data.data === true) {
      setApiConditionMet(false); // show stock report
      setNoStockAvailable(false);
    } else {
      setApiConditionMet(true); // already submitted message
      setNoStockAvailable(true);
    }
  } catch (error) {
    setError("Something went wrong");
    setApiConditionMet(true);
  } finally {
    setIsLoading(false);
  }
};
 useEffect(() => {
  checkStockData();
}, [shopId, date]);
 
 const fetchStock = async () => {
        setLoading(true);
        setError(null);
    
        const requestData = {
            shopId,
            typeId: "1",
            stockDate: date || new Date().toISOString().split("T")[0], // Ensure valid date format
        };
    
        const requestHeaders = {
            Authorization: `Bearer ${tokenString}`, // Add token to headers
        };
    
        console.log("Request being sent:", {
            url: "https://winenew.sipstocks.in/api/Liquor/GetStockProductDataWithDate",
            method: "POST",
            headers: requestHeaders,
            data: requestData,
        });
    
        try {
            const response = await axios.post(
                "https://winenew.sipstocks.in/api/Liquor/GetStockProductDataWithDate",
                requestData,
                { headers: requestHeaders }
            );
    
            console.log("Response received:", response);
    
            const fetchedProducts = response.data.data || [];
            const updatedProducts = fetchedProducts.map((product) => ({
                id: product.id,
                name: product.pName,
                variants: [
                    {
                        volume: product.packing,
                        rate: parseFloat(product.mrp),
                        openingStock: parseFloat(product.openingStock || 0),
                        receivedStock: parseFloat(product.receivedQty || 0),
                        transferStock: parseFloat(product.transferQty || 0), 
                        currentStock: "", // Initially empty for user input
                        isSubmitted: false, // Track if data has been submitted
                    },
                ],
            }));
    
            setProducts(updatedProducts);
            setFilteredProducts(updatedProducts);
    
            if (fetchedProducts.length === 0) {
                setError("No data available for this date");
            }
        } catch (err) {
            setError("Error fetching stock data");
            console.error("Error fetching stock:", err);
        } finally {
            setLoading(false);
        }
    };
    
   
   
 
 const handleInputBlur = useCallback(
   (e, productId, variantVolume, field) => {
     const { value } = e.target;
 
     console.log("Input Blurred: ", { productId, variantVolume, field, value });
 
     if (value.trim() === "") {
       console.log("Value is empty. Resetting field.");
       setProducts((prevProducts) =>
         prevProducts.map((product) =>
           product.id === productId
             ? {
                 ...product,
                 variants: product.variants.map((variant) =>
                   variant.volume === variantVolume ? { ...variant, [field]: "" } : variant
                 ),
               }
             : product
         )
       );
       return;
     }
 
     const numericValue = parseFloat(value);
     console.log("Parsed numeric value:", numericValue);
 
     // ✅ Negative या invalid input की जाँच करें
     if (isNaN(numericValue) || numericValue < 0) {
       showToast("Please enter a valid non-negative number.", "error");
       clearInput();
       return;
     }
 
     setProducts((prevProducts) =>
       prevProducts.map((product) =>
         product.id === productId
           ? {
               ...product,
               variants: product.variants.map((variant) => {
                 if (variant.volume === variantVolume) {
                   const openingStock = parseFloat(variant.openingStock || 0);
                   const receivedStock = parseFloat(variant.receivedStock || 0);
                   const transferStock = parseFloat(variant.transferStock || 0);
                   const currentStock = parseFloat(variant.currentStock || 0);
 
                   console.log("Current Variant Data:", {
                     openingStock,
                     receivedStock,
                     transferStock,
                     currentStock,
                   });
 
                   const totalStock = openingStock + receivedStock;
                   console.log("Total Stock:", totalStock);
 
                
                   if (field === "transferStock") {
                     const maxTransferStock = totalStock - currentStock;
                     console.log("Max Transfer Stock:", maxTransferStock);
                     if (numericValue > maxTransferStock) {
                       showToast(
                         `Transfer stock cannot exceed total stock minus closing stock (${maxTransferStock}).`,
                         "error"
                       );
                       clearInput();
                       return variant;
                     }
                   }
 
                 
                   if (field === "currentStock") {
                     const maxClosingStock = totalStock - transferStock;
                     console.log("Max Closing Stock:", maxClosingStock);
                     if (numericValue > maxClosingStock) {
                       showToast(
                         `Closing stock cannot exceed total stock minus transfer stock (${maxClosingStock}).`,
                         "error"
                       );
                       clearInput();
                       return variant;
                     }
                   }
 
                   console.log("Updating field:", field, "with value:", numericValue);
                   return { ...variant, [field]: numericValue };
                 }
                 return variant;
               }),
             }
           : product
       )
     );
 
   
     function clearInput() {
       setProducts((prevProducts) =>
         prevProducts.map((product) =>
           product.id === productId
             ? {
                 ...product,
                 variants: product.variants.map((variant) =>
                   variant.volume === variantVolume ? { ...variant, [field]: "" } : variant
                 ),
               }
             : product
         )
       );
     }
   },
   [toastVisible]
 );
 
const handleSubmit = async () => {
  // Use previewData if it has data, otherwise fallback to products
  const sourceData = (previewData && previewData.length > 0) ? previewData : products;

  if (!sourceData || sourceData.length === 0) {
    showToast("No product data available for submission!", "error");
    return;
  }

  const updatedProducts = sourceData
    .map((product) => {
      const variants = product.variants || [product]; // For flat previewData

      const updatedVariants = variants
        .map((variant) => {
          const currentStock =
            variant.currentStock !== null &&
            variant.currentStock !== undefined &&
            variant.currentStock !== ""
              ? parseFloat(variant.currentStock)
              : null;

          // Skip if currentStock is not entered
          if (currentStock === null || isNaN(currentStock)) return null;

          const receivedStock = parseFloat(variant.receivedStock) || 0;
          const transferStock = parseFloat(variant.transferStock) || 0;
          const openingStock = parseFloat(variant.openingStock) || 0;
          const rate = parseFloat(variant.rate) || 0;

          const soldStock = openingStock + receivedStock - (currentStock + transferStock);
          const totalAmount = soldStock * rate;

          return {
            productId: product.id || variant.productId, // Handle previewData flat structure
            receivedStock,
            transferStock,
            currentStock,
            soldStock,
            totalAmount,
            shopId,
            stockDate: date || new Date().toISOString().split("T")[0],
          };
        })
        .filter((variant) => variant !== null);

      return updatedVariants.length > 0 ? updatedVariants : null;
    })
    .filter((product) => product !== null)
    .flat();

  if (updatedProducts.length === 0) {
    showToast("No valid products with current stock to submit!", "error");
    return;
  }

  console.log("Submitting Data:", updatedProducts);

  try {
    setLoading(true);
    const response = await axios.post(
      "https://winenew.sipstocks.in/api/Liquor/SaveProductDataWithDate",
      updatedProducts,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
      }
    );

    console.log("Submitted Data Response:", response);

    if (response.status === 200) {
      if (
        response.data &&
        response.data.data === "Negative stock detected after transaction."
      ) {
        showToast("Negative stock detected!", "error");
      } else {
        showToast("Stock report submitted successfully!", "success");
        // setTimeout(() => window.location.reload(), 2000);
        await checkStockData();   // re-check status after submit
        await fetchStock();       // reload table data (optional)
      }
    } else {
      showToast(`Error submitting stock report: ${response.statusText}`, "error");
    }
  } catch (error) {
    showToast("Error submitting stock report!", "error");
    console.error("API Error:", error);
  } finally {
    setLoading(false);
  }
};


 
   const handleKeyDown = (e, currentIndex) => {
     if (e.key === 'Enter') {
       e.preventDefault();
 
       // Move to the next input field
       const nextInput = inputRefs.current[currentIndex + 1];
       if (nextInput) {
         nextInput.focus();
       }
     }
   };
 
 
 
   useEffect(() => {
     const fetchReceiveTypes = async () => {
       try {
         const response = await axios.post(
           'https://winenew.sipstocks.in/api/Liquor/GetRecTypeMst',
           {shopId , companyId},
           { headers: { accept: '*/*' } }
         );
       console.log("fetchReceiveTypes",response)
 
         const options = response.data?.data?.map((item) => ({
           id: item.id,
           label: item.name,
           type:item.typeName
         }));
          setReceiveTypes(options);
       } catch (err) {
         console.error('Error fetching dropdown options:', err);
         showToast('Failed to load dropdown options.',"error");
       }
     };
     fetchReceiveTypes();
   }, []);
 
 


    // Function to get label by ID
    const getLabelById = (options, id) => {
     const option = options.find((option) => option.id === id);
     return option ? option.label : 'Not Selected'; // Default to 'Not Selected' if no label found
   };
 
 


   useEffect(() => {
     const fetchTransferTypes = async () => {
       try {
         const response = await axios.post(
           'https://winenew.sipstocks.in/api/Liquor/GetTypeMst',
           {shopId , companyId},
           { headers: { accept: '*/*' } }
         );
       console.log("fetchTransferTypes",response)
 
         const options = response.data?.data?.map((item) => ({
           id: item.id,
           label: item.name,
         }));
         setTransferTypes(options);
       } catch (err) {
         console.error('Error fetching dropdown options:', err);
         showToast('Failed to load dropdown options.',"error");
       }
     };
     fetchTransferTypes();
   }, []);
 



   useEffect(() => {
     const fetchPartyMasters = async () => {
       try {
         const response = await axios.post(
           'https://winenew.sipstocks.in/api/Liquor/GetPartyMaster',
           {companyId:companyId},
           { headers: { accept: '*/*' } }
         );
       console.log("fetchPartyMasters",response)
 
         const options = response.data?.data?.map((item) => ({
           id: item.id,
           label: item.name,
         }));
         console.log("options",options)
         setPartyMasters(options);
       } catch (err) {
         console.error('Error fetching dropdown options:', err);
         showToast('Failed to load dropdown options.',"error");
       }
     };
     fetchPartyMasters();
   }, []);
 
   const calculateTotalAmount = () => {
     const total = products.reduce((productSum, product) => {
       return (
         productSum +
         product.variants.reduce((variantSum, variant) => {
           const openingStock = parseFloat(variant.openingStock || 0);
           const receivedStock = parseFloat(variant.receivedStock || 0);
           const currentStock = variant.currentStock; 
           const transferStock = parseFloat(variant.transferStock || 0);
   
           
           if (currentStock !== undefined && currentStock !== null && currentStock !== "") {
             const parsedCurrentStock = parseFloat(currentStock);
   
 
             const totalStock = openingStock + receivedStock;
   
           
             const soldStock = totalStock - (transferStock + parsedCurrentStock);
   
    
             return variantSum + soldStock * parseFloat(variant.rate || 0);
           }
   
           return variantSum;
         }, 0)
       );
     }, 0);
   
     setTotalAmount(total.toFixed(2)); 
   };
   
   useEffect(() => {
     calculateTotalAmount(); 
   }, [products]);
   
 
 
 
 
   const handlePopupOpen = (product, variant) => {
     console.log("Product:", product);
     console.log("Variant:", variant);
   
     // Extract only the volume
     const variantString = variant && variant.volume ? variant.volume : ""; 
   
     console.log("Variant String:", variantString); // Debugging
   
     setPopupData({
       productName: product.name,
       Variant: variantString, 
       variant, // Store only volume
       product,
       receivedHeadId: "",
       receivedHeadLabel: "",
       receivedPartyMaster: "",
       receivedStockInput: "",
     });
   
     setIsPopupOpen(true);
   };
   
   const handlePopupClose = () => {
     setIsPopupOpen(false);
     setPopupData({
       product: null,
       variant: null,
       receivedHeadId: "",
       receivedPartyMaster: "",
       receivedStockInput: "",
       invoiceNo: '',
     });
     setSubmittedData(null);
     
   };
   
   const handlePopupSubmit = async () => {
     if (isSubmitting) return; // Prevent multiple clicks
   
     const {
       product,
       variant,
       receivedHeadId,
       receivedHeadType,
       receivedPartyMaster,
       receivedStockInput,
       invoiceNo,
       shopToShop,
     } = popupData;
   
     // Step 1: Validate required fields
     if (!receivedHeadId) {
       showToast("Please select the received head.","error");
       return;
     }
   
     if (receivedHeadType !== "RSBCL" && receivedHeadType !== "SHOP" && !receivedPartyMaster) {
       showToast("Please select the received party.","error");
       return;
     }
   
     if (receivedHeadType === "SHOP" && !shopToShop) {
       showToast("Please select a shop to proceed.","error");
       return;
     }
   
     if (!receivedStockInput || parseFloat(receivedStockInput) <= 0) {
       showToast("Please enter a valid stock.","error");
       return;
     }
   
     if (product && variant && parseFloat(receivedStockInput) > 0) {
       setIsSubmitting(true); // Disable button while processing
   
       // Update variant details
       variant.receivedHeadId = receivedHeadId;
       variant.receivedPartyMaster = receivedHeadType === "RSBCL" ? null : receivedPartyMaster;
       variant.shopToShop = receivedHeadType === "SHOP" ? shopToShop : null;
       variant.receivedStock = parseFloat(variant.receivedStock || 0) + parseFloat(receivedStockInput || 0);
       variant.invoiceNo = invoiceNo || null;
   
       setProducts((prevProducts) =>
         prevProducts.map((prevProduct) => {
           if (prevProduct.id === product.id) {
             return {
               ...prevProduct,
               variants: prevProduct.variants.map((prevVariant) =>
                 prevVariant.id === variant.id ? { ...prevVariant, ...variant } : prevVariant
               ),
             };
           }
           return prevProduct;
         })
       );
   
       const dataToSend = {
         productId: product.id,
         shopId: shopId,
         receivedHeadId: receivedHeadId,
         receivedHeadQty: parseFloat(receivedStockInput || 0),
         receivedPartyId: receivedHeadType === "RSBCL" || receivedHeadType === "SHOP" ? "0" : receivedPartyMaster,
         receivedShopId: receivedHeadType === "SHOP" ? shopToShop : shopId,
       };
   
       console.log("Data to send:", dataToSend);
   
       try {
         const response = await axios.post(
           "https://winenew.sipstocks.in/api/Liquor/SaveProductReceivedDetails",
           dataToSend,
           {
             headers: {
               Accept: "*/*",
               "Content-Type": "application/json",
               Authorization: `Bearer ${tokenString}`,
             },
           }
         );
   
         console.log("API Response:", response.data);
         showToast("Data successfully submitted!","success");
       } catch (error) {
         console.error("Error submitting data to API:", error.response?.data || error.message);
         showToast("Failed to submit data to the API. Please try again.","success");
       } finally {
         setIsSubmitting(false); // Re-enable button after request completes
         setPopupData(); // Reset popup data
         handlePopupClose(); // Close the popup
       }
     }
   };
   
     const handleTransferStockPopupOpen = (product, variant) => {
     const variantString = variant && variant.volume ? variant.volume : ""; 
   
     console.log("Variant String:", variantString); // Debugging
     setTransferStockPopupData({
       productName: product.name,
       Variant: variantString, 
       
       product,
       variant,
   
       transferHeadId:  "",
       transferPartyMaster:  "",
       transferStockInput: "",
     });
     setIsTransferStockPopupOpen(true);
   };
 
  const handleTransferStockPopupClose = () => {
     setIsTransferStockPopupOpen(false);
     setTransferStockPopupData({
       product: null,
       variant: null,
       transferHeadId: "",
       transferPartyMaster: "",
       transferStockInput: "",
     });
   };
 
 
 
   useEffect(() => {
     console.log("Updated receiveDetailDtos:", receiveDetailDtos);
   }, [receiveDetailDtos]);
 
 
 
 
   const handleTransferSubmit = async () => {
     const { 
       product, 
       variant, 
       transferPartyMaster, 
       transferStockInput, 
       transferType, 
       shopToShop 
     } = transferStockPopupData;
   
     console.log("shopToShop:", shopToShop);
   
     // Step 1: Check if transferType is selected
     if (!transferType) {
       showToast('Please select the Transfer Head.',"error");
       return;
     }
   
     // Step 2: Validate based on transferType
     if (transferType === "3") {
       // For "3", shopToShop must be selected
       if (!shopToShop) {
         showToast('Please select the Shop for transfer.',"error");
         return;
       }
     } else {
       // For other types, transferPartyMaster must be selected
       if (!transferPartyMaster) {
         showToast('Please select the Transfer Party.',"error");
         return;
       }
     }
   
     // Step 3: Validate transferStockInput
     if (!transferStockInput || parseFloat(transferStockInput) <= 0) {
       showToast('Please enter a valid stock.',"error");
       return;
     }
   
     const transferStock = parseFloat(transferStockInput || 0);
   
     // Step 4: Validate total stock availability
     const openingStock = parseFloat(variant.openingStock || 0);
     const receivedStock = parseFloat(variant.receivedStock || 0);
     const totalStock = openingStock + receivedStock;
   
     if ((variant.transferStock || 0) + transferStock > totalStock) {
       showToast('Transfer stock exceeds available stock.',"error");
       return;
     }
   
     // If all validations pass, proceed with the logic
     if (product && variant) {
       variant.transferHeadId = transferType;
       variant.transferPartyMaster = transferPartyMaster;
       variant.transferStock = (variant.transferStock || 0) + transferStock;
       variant.shopToShop = transferType === "3" ? shopToShop : null; // Set shopToShop only if transferType is "3"
     }
   
     setProducts((prevProducts) =>
       prevProducts.map((prevProduct) => {
         if (prevProduct.id === product.id) {
           return {
             ...prevProduct,
             variants: prevProduct.variants.map((prevVariant) =>
               prevVariant.id === variant.id ? { ...prevVariant, ...variant } : prevVariant
             ),
           };
         }
         return prevProduct;
       })
     );
   
     // Prepare data to send to API
     const dataToSend = {
       shopId,
       productId: product.id,
       transferHeadId: transferType,
       transferHeadQty: transferStock,
       transferPartyId: transferType === "3" ? null : transferPartyMaster, // Transfer Party not required for type "3"
       transferShopId: transferType === "3" ? shopToShop : shopId,
     };
   
     console.log("dataToSendintransfer", dataToSend);
   
     settransferDetailDtos1((prev) => [...prev, dataToSend]);
   
     // Disable the button while the API request is processing
     setIsButtonDisabled1(true);
   
     try {
       const response = await axios.post(
         'https://winenew.sipstocks.in/api/Liquor/SaveProductTransferDetails',
         dataToSend,
         {
           headers: {
             Accept: '*/*',
             'Content-Type': 'application/json',
             Authorization: `Bearer ${tokenString}`,
           },
         }
       );
   
       console.log('API Response transfer:', response.data);
       showToast('Transfer successfully processed!',"success");
     } catch (error) {
       console.error('Error submitting transfer details to API:', error.response?.data || error.message);
       showToast('Failed to submit transfer details. Please try again.',"error");
     } finally {
       // Re-enable the button regardless of success or failure
       setIsButtonDisabled1(false);
     }
   
     console.log('Transfer successfully processed:', transferDetailDtos1);
     handleTransferStockPopupClose();
   };
   
   
   
   
 
 
 
 
 
   useEffect(() => {
     // Function to fetch shop options from the API
     const fetchShopOptions = async () => {
       try {
         const response = await axios.post(
           'https://winenew.sipstocks.in/api/Liquor/GetShopMaster', // API URL
           { userId ,companyId}, // Request body with userId
           {
             headers: {
               'accept': '*/*', // Accept header
               'Content-Type': 'application/json' // Content-Type header
             }
           }
         );
         console.log("fetchShopOptions:", response)
   
         const options = response.data?.data?.map((item) => ({
           id: item.id,
           label: item.name,
         }));
         console.log("options",options)
         
         // Assuming the API returns an array of shop options
         setShopOptions(options);
         setIsLoading(false); // Set loading to false after data is fetched
       } catch (err) {
         setError('Failed to fetch shop options');
         setIsLoading(false);
       }
     };
   
     fetchShopOptions(); // Call the function to fetch data
   }, []); // Empty dependency array means this runs only once when the component mounts
   
   
 
 
 
 
 
 
 
 
 
 
 
 
   
//    const handlePreview = () => {
//      if (filteredProducts.length === 0) {
//          showToast("No product data available for preview!", "error");
//          return;
//      }
 
//      const hasValidStock = filteredProducts.some((product) =>
//          product.variants.some((variant) =>
//              variant.currentStock !== undefined &&
//              variant.currentStock !== null &&
//              variant.currentStock !== ""
//          )
//      );
 
//      if (!hasValidStock) {
//          showToast("No valid stock input provided!", "error");
//          return;
//      }
 
//      const updatedProducts = filteredProducts
//          .map((product) => {
//              const updatedVariants = product.variants
//                  .map((variant) => {
//                      if (variant.currentStock === undefined || variant.currentStock === null || variant.currentStock === "") {
//                          return null;
//                      }
 
//                      const receivedStock = variant.receivedStock ? parseFloat(variant.receivedStock) : 0;
//                      const transferStock = variant.transferStock ? parseFloat(variant.transferStock) : 0;
//                      const currentStock = parseFloat(variant.currentStock);
//                      const openingStock = variant.openingStock ? parseFloat(variant.openingStock) : 0;
//                      const rate = variant.rate ? parseFloat(variant.rate) : 0;
 
//                      const totalstock = openingStock + receivedStock;
//                      const maxStock = Math.max(totalstock - transferStock, 0); // **🔹 Ensure maxStock is never negative**
                     
//                      console.log("Max Stock (Allowed Closing Stock):", maxStock);
//                      console.log("Current Stock Entered:", currentStock);
 
//                      // **✅ Ensure currentStock does not exceed maxStock**
//                      if (currentStock > maxStock) {
//                          showToast(`Current stock cannot be more than (${maxStock}) for ${product.name}`, "error");
//                          return null;
//                      }
 
//                      // **✅ Ensure soldStock is correctly calculated based on maxStock**
//                      let soldStock = Math.max(maxStock - currentStock, 0);
//                      let totalAmount = soldStock * rate;
 
//                      return {
//                          productName: product.name,
//                          openingStock,
//                          rate,
//                          receivedStock,
//                          transferStock,
//                          currentStock,
//                          soldStock,
//                          totalAmount,
//                          shopId,
//                          stockDate: date || new Date().toISOString().split("T")[0],
//                      };
//                  })
//                  .filter((variant) => variant !== null);
 
//              return updatedVariants.length > 0 ? updatedVariants : null;
//          })
//          .filter((product) => product !== null)
//          .flat();
 
//      setPreviewData(updatedProducts);
//      setShowPreview(true);
//  };
 


const handlePreview = () => {
    // Use the original products instead of filteredProducts
    if (products.length === 0) {
        showToast("No product data available for preview!", "error");
        return;
    }

    const hasValidStock = products.some((product) =>
        product.variants.some((variant) =>
            variant.currentStock !== undefined &&
            variant.currentStock !== null &&
            variant.currentStock !== ""
        )
    );

    if (!hasValidStock) {
        showToast("No valid stock input provided!", "error");
        return;
    }

    const updatedProducts = products
        .map((product) => {
            const updatedVariants = product.variants
                .map((variant) => {
                    if (
                        variant.currentStock === undefined ||
                        variant.currentStock === null ||
                        variant.currentStock === ""
                    ) {
                        return null;
                    }

                    const receivedStock = variant.receivedStock ? parseFloat(variant.receivedStock) : 0;
                    const transferStock = variant.transferStock ? parseFloat(variant.transferStock) : 0;
                    const currentStock = parseFloat(variant.currentStock);
                    const openingStock = variant.openingStock ? parseFloat(variant.openingStock) : 0;
                    const rate = variant.rate ? parseFloat(variant.rate) : 0;

                    const totalstock = openingStock + receivedStock;
                    const maxStock = Math.max(totalstock - transferStock, 0);

                    if (currentStock > maxStock) {
                        showToast(`Current stock cannot be more than (${maxStock}) for ${product.name}`, "error");
                        return null;
                    }

                    let soldStock = Math.max(maxStock - currentStock, 0);
                    let totalAmount = soldStock * rate;

return {
  productId: product.id,                 // ✅ keep productId
  variantId: variant.id || variant.volume, // ✅ something unique for variant
  productName: product.name,
  openingStock,
  rate,
  receivedStock,
  transferStock,
  currentStock,
  soldStock,
  totalAmount,
  shopId,
  stockDate: date || new Date().toISOString().split("T")[0],
};
                })
                .filter((variant) => variant !== null);

            return updatedVariants.length > 0 ? updatedVariants : null;
        })
        .filter((product) => product !== null)
        .flat();

    setPreviewData(updatedProducts);
    setShowPreview(true);
};





 const applyPreviewChanges = () => {
  const updated = filteredProducts.map((product) => {
    const updatedVariants = product.variants.map((variant) => {
      const updatedVariant = previewData.find(
        (item) =>
          item.productName === product.name &&
          item.openingStock === variant.openingStock &&
          item.rate === variant.rate &&
          parseFloat(item.receivedStock) === parseFloat(variant.receivedStock) &&
          parseFloat(item.transferStock) === parseFloat(variant.transferStock)
      );

   if (updatedVariant) {
  return {
    ...variant,
    productId: updatedVariant.productId,   // ✅ always preserved
    currentStock: updatedVariant.currentStock,
    soldStock: updatedVariant.soldStock,
    totalAmount: updatedVariant.totalAmount,
  };
}
      return variant;
    });

    return {
      ...product,
      variants: updatedVariants,
    };
  });

  setFilteredProducts(updated); // update main UI
};

   
 
 
 
 const handleStockChange = (index, newStock) => {
   setPreviewData((prevData) =>
     prevData.map((item, i) => {
       if (i === index) {
         
      
         if (newStock === "") {
           return { ...item, currentStock: "", soldStock: "", totalAmount: "" };
         }
 
         const updatedStock = parseFloat(newStock);
 
     
         if (isNaN(updatedStock) || updatedStock < 0) {
           showToast("Current Stock cannot be negative!", "error");
           return clearInput(item);
         }
 
        
         const maxStock = (item.openingStock + item.receivedStock) - item.transferStock;
 
      
         if (updatedStock > maxStock) {
           showToast(`Current Stock cannot be more than ${maxStock}!`, "error");
           return clearInput(item);
         }
 
     
         const soldStock = maxStock - updatedStock;
         const totalAmount = soldStock * (item.rate || 0);
 
         return { ...item, currentStock: updatedStock, soldStock, totalAmount };
       }
       return item;
     })
   );
 
 
   function clearInput(item) {
     return { ...item, currentStock: "", soldStock: "", totalAmount: "" };
   }
 };
 
 
 
 
 
 

 
 
 
 
 const handletransferUpdateStock = async (item, index) => {
   setUpdatingIndex(index); 
 
   try {
     // Prepare the updated data for the API request
     const requestBody = {
       id: item.id,
       productId: item.productId,
       shopId: item.shopId,
       transferShopId: transferStockPopupData[item.id]?.shopToShop || item.shopToShop,
       transferHeadId: item.transferHeadId,
       transferPartyId: item.transferPartyId,
       transferHeadQty: item.qty, // Use the updated quantity
     };
 
     console.log("updateRequestBody:", requestBody);
 
     // Sending the API request using axios
     const response = await axios.post(
       "https://winenew.sipstocks.in/api/Liquor/UpdateProductTransferDetails",
       requestBody,
       { headers: { Authorization: `Bearer ${tokenString}` } }
     );
 
     console.log("updated transfer stock", response);
 
     // Check the response status
     if (response.data.code === 200) {
       showToast("Stock updated successfully!","success");
     } else {
       showToast("Error updating stock!","error");
     }
   } catch (error) {
     console.error("Error updating stock:", error);
     showToast("Failed to update stock!","error");
   } finally {
     setUpdatingIndex(null); 
   }
 };
 
 
 
 
 const fetchTransactionData = async (product, variant, type) => {
   try {
     const response = await axios.post(
       "https://winenew.sipstocks.in/api/Liquor/GetDailyTransaction",
       {
         shopId: shopId,
         stockDate: date || new Date().toISOString().split("T")[0],
       },
       {
         headers: {
           Accept: "*/*",
           "Content-Type": "application/json",
         },
       }
     );
 
     console.log("Full API Response:", JSON.stringify(response.data, null, 2));
 
     if (response.data?.code === 200) {
       if (type === "received") {
         let filteredData = response.data.data?.trnReceived?.filter(
           (item) => item.productId === product.id
         ) || [];
 
         console.log("Filtered Received Data:", filteredData);
 
         // ✅ Popup Data
         setPopupData1(filteredData);
         setShowPopup(true);
 
         // ✅ Total Received Qty निकालें
         const totalQty = filteredData.reduce((sum, item) => sum + (item.qty || 0), 0);
 
         setReceivedStockData((prev) => ({
           ...prev,
           [product.id]: totalQty,
         }));
       } 
       else if (type === "transfer") {
         let filteredTransferData = response.data.data?.trnTransfer?.filter(
           (item) => item.productId === product.id
         ) || [];
 
         console.log("Filtered Transfer Data:", filteredTransferData);
 
         // ✅ Popup Data
         setPopupData2(filteredTransferData);
         setShowPopup2(true);
 
         // ✅ Total Transfer Qty निकालें
         const totalTransferQty = filteredTransferData.reduce((sum, item) => sum + (item.qty || 0), 0);
 
         setTransferStockData((prev) => ({
           ...prev,
           [product.id]: totalTransferQty,
         }));
       }
     } else {
       setPopupData1([]);
       setPopupData2([]);
     }
   } catch (error) {
     console.error("Error fetching transaction data:", error.response?.data || error.message);
   }
 };
   


  return (
    <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
    {/* Content wrapper */}
    <div className="d-flex flex-column flex-column-fluid">
        {/* Toolbar */}
        <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
            {/* Toolbar container */}
            <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                {/* Page title */}
                <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    {/* Title */}
                    <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
                    Stock Management
                    </h1>
                    <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <li className="breadcrumb-item text-muted">
                            <a href="index.html" className="text-muted text-hover-primary">Home</a>
                        </li>
                        <li className="breadcrumb-item">
                            <span className="bullet bg-gray-500 w-5px h-2px"></span>
                        </li>
                        <li className="breadcrumb-item text-muted">Dashboards</li>
                    </ul>
                </div>
            </div>
        </div>
  
        <div id="kt_app_content" className="app-content flex-column-fluid">
            <div id="kt_app_content_container" className="app-container container-fluid">
                <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                    <div className="col-xl-12">
                        <div className="card card-flush h-md-100">
                            <ToastContainer />
                           
                            <div className="card-body pt-6">
                                <div className="table-responsive">
                                    <div className="panel-body">
                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                            <form className="form-inline">
                                                <div className="form-group">
                                                    <p className="form-control-static">Search Products:</p>
                                                </div>
                                                <div className="form-group d-flex justify-content-between gap-5">
                                                    <label htmlFor="inputsearch" className="sr-only active">Search Products</label>
                                                    <input className="form-control " id="inputsearch" placeholder="Search Products"   value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}type="text"  autoComplete="off" />
                                                    

                                                    <input
    className="form-control "
    id="inputsearch"
    placeholder="Search Products"
    type="date"
    value={date} // Always in correct format
    max={new Date().toISOString().split("T")[0]} // Restrict future dates
    onChange={(e) => setDate(e.target.value)} // Update state
    autoComplete="off"
  />
                                                </div>

                                            </form>
                                        </div>
                                        <div className="clearfix"></div>
                                        <br />
                                        {apiConditionMet === null ? (
    <div className="loader-container">
             <FaSpinner className="spinner-icon" />
           </div>
  ) : apiConditionMet ? (
                                        <div className="table-responsive  h-700px">
                                            <table className="table table-bordered table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>S. No.</th>
                                                        <th>Product Name</th>
                                                        <th>Variant</th>
                                                        <th>Rate</th>
                                                        <th>Opening Stock</th>
                                                        <th>Received Stock</th>
                                                     
                                                        <th>Transfer Stock</th>
                                                        <th>Total Stock</th>
                                                        <th>Closing Stock</th>
                                                        <th>Sold Stock</th>
                                                        <th>Total Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
  {filteredProducts.length > 0 ? (
  filteredProducts.map((product, index) =>
  product.variants.map((variant, vIndex) => {
  
  
  
  
  const totalStock = (variant.openingStock + variant.receivedStock)-variant.transferStock;
  const currentStock = parseFloat(variant.currentStock);
  const soldStock = totalStock - currentStock  || 0;
  const totalAmount = soldStock * (parseFloat(variant.rate) || 0);
  
  return (
    <tr key={`${index}-${vIndex}`}>
      <td>{index + 1}</td>
      <td>{product.name}</td>
      <td>{variant.volume}</td>
      <td className="numeric-input">{variant.rate}</td>
      <td className="numeric-input">{variant.openingStock}</td>
      
      {/* Received Stock Pehle Se Show Ho */}
      {/* <td className="numeric-input">{variant.receivedStock}</td> */}
  
      <td className="numeric-input">
       <button
  data-bs-toggle="modal"
  data-bs-target="#exampleModal"
  className="btn btn-warning btn-sm d-block p-1"
  onClick={() => fetchTransactionData(product, variant, "received")}
  >
  {variant.receivedStock}
  </button>
    </td>
  
      {/* Total Stock Calculation */}
   
  
      <td className="numeric-input">
        <button
         data-bs-toggle="modal"
         data-bs-target="#model2"
         className="btn btn-warning btn-sm d-block p-1"
          onClick={() => fetchTransactionData(product, variant, "transfer")}
        >
        {variant.transferStock}
        </button>
      </td>
      <td className="numeric-input">{totalStock}</td>
  
      <td>
        <input
          type="text"
          value={variant.currentStock}
          onChange={(e) =>
            handleInputBlur(e, product.id, variant.volume, 'currentStock')
          }
          className="numeric-input"
        />
      </td>
      <td className="numeric-input">{soldStock}</td>
      <td className="numeric-input">{totalAmount.toFixed(2)}</td>
    </tr>
  );
  })
  )
  ) : (
  <tr>
  <td colSpan="13" className="text-center">
 No Data Found
  </td>
  </tr>
  )}
  </tbody>
       </table>
   </div>
                                          ) : (
                                            <div className="alert alert-success">
  ✅ Already submitted data.
</div>
                                          )}
                                          


                                          <div className="total-amount-display" style={{ textAlign: "left" }}>
  <h3 className="total-amount-text">Total Amount: ₹{totalAmount}</h3>
</div>


                                          <div class="text-right align-items-right d-flex justify-content-end">
      <button type="submit" data-bs-toggle="modal" data-bs-target="#model3" className="btn btn-info mt-3 m-2"  onClick={handlePreview}>Preview</button>
       <button type="submit" className="btn btn-info mt-3 m-2"    onClick={handleSubmit}disabled={loading}   >{loading ? "Submitting..." : "Submit Report"}</button>
       </div>


                                          
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  
    {/* Footer */}
    <div id="kt_app_footer" className="app-footer">
        <div className="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3">
            <div className="text-gray-900 order-2 order-md-1">
                <span className="text-muted fw-semibold me-1">2025&copy;</span>
                <a href="#" target="_blank" className="text-gray-800 text-hover-primary">WineShop</a>
            </div>
        </div>
    </div>




    
    <div
  className="modal fade"
  id="exampleModal"
  tabIndex={-1}
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  >
  <div className="modal-dialog modal-lg">
  <div className="modal-content">
  <div className="modal-header">
  <h1 className="modal-title fs-5" id="exampleModalLabel">
  Received Stock Details
  </h1>
  <button
  type="button"
  className="btn-close"
  data-bs-dismiss="modal"
  aria-label="Close"
  />
  </div>
  
  <div className="modal-body">
  <div className="popup-content">
  <h4>Received Stock Details</h4>
  {popupData1 && popupData1.length > 0 ? (
    <table className="table table-bordered table-striped">
      <thead>
        <tr>
          <th>Product Name</th>
          <th>Receive Type</th>
          <th>Details</th>
          <th>Quantity</th>
        </tr>
      </thead>
      <tbody>
        {popupData1.map((item, index) => (
          <tr key={item.id || index}>
            <td>{item.productName || "N/A"}</td>
            <td>{item.receivedHead || "N/A"}</td>
            <td>
              {item.receivedHead === "RSBCL"
                ? `Invoice No: ${item.invoiceNo || "N/A"}`
                : item.receivedHeadType === "SHOP" || item.receivedHeadType === "SHOP TO SHOP"
                ? `Shop: ${item.selectedShop || "N/A"}`
                : `Party: ${item.receivedHeadName || "N/A"}`}
            </td>
            <td>{item.qty || "0"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <EmptyState />
  )}
  </div>
  </div>
  
  <div className="modal-footer">
  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
  Close
  </button>
  </div>
  </div>
  </div>
  </div>
  
  
  
  
  
  
  
  {/* For transfer modal */}
  
  
  <div
  className="modal fade"
  id="model2"
  tabIndex={-1}
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  >
  <div className="modal-dialog modal-lg">
  <div className="modal-content">
  <div className="modal-header">
  <h1 className="modal-title fs-5" id="exampleModalLabel">
  Transfer Stock Details
  </h1>
  <button
  type="button"
  className="btn-close"
  data-bs-dismiss="modal"
  aria-label="Close"
  />
  </div>
  
  <div className="modal-body">
  <div className="popup-content">
  <h4>Transfer Stock Details</h4>
  {popupData2 && popupData2.length > 0 ? (
    <table className="table table-bordered table-striped">
      <thead>
        <tr>
        <th>Product Name</th>
      <th>Transfer Head</th>
      <th>Invoice / Party / Shop</th>
      <th>Quantity</th>
        </tr>
      </thead>
      <tbody>
        {popupData2.map((item, index) => (
          <tr key={item.id || index}>
            <td>{item.productName || "N/A"}</td>
            <td>{item.transferHead || "N/A"}</td>
            <td>
          {item.invoiceNo
            ? ` ${item.invoiceNo}`
            : item.transferPartyName
            ? ` ${item.transferPartyName}`
            : item.transferShopName
            ? ` ${item.transferShopName}`
            : "N/A"}
        </td>
            <td>{item.qty || "0"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <EmptyState />
  )}
  </div>
  </div>
  
  <div className="modal-footer">
  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
  Close
  </button>
  </div>
  </div>
  </div>
  </div>
  
  
  
  
  
      {/* Preview modal */}
  
      <div
  className="modal fade"
  id="model3"
  tabIndex={-1}
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  >
  <div className="modal-dialog modal-lg">
  <div className="modal-content">
  <div className="modal-header">
  <h1 className="modal-title fs-5" id="exampleModalLabel">
  Preview Details
  </h1>
  <button
  type="button"
  className="btn-close"
  data-bs-dismiss="modal"
  aria-label="Close"
  />
  </div>
  
  <div className="modal-body">
  <div className="previewdata">
          <table className="table table-bordered table-striped" >
            <thead>
              <tr>
                <th>Product Name</th>
                <th>Opening Stock</th>  {/* ✅ New Column for Opening Stock */}
                <th>Rate</th> 
                <th>Received Stock</th>
                <th>Transfer Stock</th>
                <th>Current Stock</th>
                <th>Sold Stock</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody>
            {previewData.map((item, index) => (
                <tr key={index}>
                  <td>{item.productName}</td>
                  <td>{item.openingStock}</td>  {/* ✅ Display Opening Stock */}
                  <td>{item.rate}</td> 
                  <td>{item.receivedStock}</td>
                  <td>{item.transferStock}</td>
         <td>
        <input
          type="text"
          value={item.currentStock === null || item.currentStock === undefined ? "" : item.currentStock}
          onChange={(e) => handleStockChange(index, e.target.value)}
          className="numeric-input"
        />
      </td>
                  <td>{item.soldStock}</td>
                  <td>{item.totalAmount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
  </div>
  
  <div className="modal-footer">
  <button
  type="button"
  className="btn btn-secondary"
  data-bs-dismiss="modal"
  onClick={applyPreviewChanges}
>
  Save & Close
</button>
  </div>
  </div>
  </div>
  </div>
  
  </div>
    );
};

export default Stock;
